export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser();
  const meta = (user.value?.app_metadata ?? {}) as Record<string, unknown>;
  const isAdmin = meta.isAdmin === true || meta.role === "admin";
  if (!isAdmin) {
    return navigateTo("/");
  }
});
